import { css } from 'aphrodite';
import type { StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { ComplianceVerdict, VerdictTone, getModeLabel } from './complianceDerived';
import { styleSheet } from './styles';

const toneStyles: Record<VerdictTone, StyleDeclarationValue> = {
	fail: styleSheet.verdictFail,
	pass: styleSheet.verdictPass,
	warn: styleSheet.verdictWarn,
	info: styleSheet.verdictInfo,
	neutral: styleSheet.verdictNeutral,
};

export const VerdictBanner = ({
	verdict,
	mode,
	children,
}: React.PropsWithChildren<{ verdict: ComplianceVerdict; mode?: string }>) => {
	const modeLabel = getModeLabel(mode);
	return (
		<div className={css(styleSheet.verdict, toneStyles[verdict.tone])}>
			<div className={css(styleSheet.verdictHead)}>
				<span className={css(styleSheet.verdictIcon)} aria-hidden>
					{verdict.icon}
				</span>
				<div>
					<h2 className={css(styleSheet.verdictHeadline)}>
						{verdict.headline}
						{modeLabel ? <span className={css(styleSheet.verdictModeChip)}>{modeLabel}</span> : null}
					</h2>
					<p className={css(styleSheet.verdictSub)}>{verdict.sub}</p>
					{verdict.reason ? <p className={css(styleSheet.verdictReason)}>{verdict.reason}</p> : null}
				</div>
			</div>
			{verdict.next ? <p className={css(styleSheet.verdictNext)}>{verdict.next}</p> : null}
			{children ? <div className={css(styleSheet.actions)}>{children}</div> : null}
		</div>
	);
};
